import { ChangeDetectionStrategy, Component, ElementRef, viewChild } from '@angular/core';

@Component({
  selector: 'fr8bot-web-parallax-bg',
  host: {
    '(window:scroll)': 'onWindowScroll()',
  },
  templateUrl: './web-parallax-bg.html',
  styleUrl: './web-parallax-bg.scss',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebParallaxBg {
  readonly liveCapacitySection = viewChild<ElementRef<HTMLElement>>('liveCapacitySection');

  parallaxOffset = 0;

  private readonly parallaxSpeed = 0.25;

  onWindowScroll(): void {
    this.updateParallax();
  }

  private updateParallax(): void {
    const section = this.liveCapacitySection()?.nativeElement;

    if (!section) {
      return;
    }

    const rect = section.getBoundingClientRect();
    const isSectionVisible = rect.top < window.innerHeight && rect.bottom > 0;

    if (!isSectionVisible) {
      return;
    }

    this.parallaxOffset = rect.top * -this.parallaxSpeed;
  }
}
